export { TAB_SESSION_MANAGER, TAB_FORM_BUILDER } from 'entry/workspace/constants/tabKeys';

export const CONFIRMATIONS = 'confirmations';
export const GUESTLIST = 'guestlist';
export const EMAIL = 'email';
export const EVENT_SETTINGS = 'eventSettings';
export const SESSIONS = 'sessions';
